import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InterestTierrateFormatPipe } from './interest-tierrate-format.pipe';

@NgModule({
  declarations: [InterestTierrateFormatPipe],
  imports: [CommonModule],
  exports: [InterestTierrateFormatPipe],
})
export class InterestTierrateFormatModule {}
